var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 9,
    viewBox: "0 0 13 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7922 6.49765L7.00172 0.70726C6.86791 0.573455 6.68951 0.499999 6.49514 0.499999C6.30469 0.499999 6.12617 0.573455 5.99258 0.70726L0.207472 6.49216C0.0736672 6.62607 5.51164e-07 6.80458 5.67814e-07 6.99504C5.84464e-07 7.18549 0.0735616 7.36411 0.207472 7.49791L0.633513 7.92396C0.767318 8.05776 0.945936 8.13164 1.13639 8.13164C1.32685 8.13164 1.50536 8.05776 1.63927 7.92396L6.49715 3.06607L11.3604 7.92956C11.4942 8.06326 11.6727 8.13703 11.8633 8.13703C12.0538 8.13703 12.2322 8.06326 12.3661 7.92956L12.7922 7.5033C13.0693 7.22608 13.0693 6.77488 12.7922 6.49765Z",
    fill: "#39695B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpIcon);
export default __webpack_public_path__ + "static/media/upIcon.049d157577c44d4b3d0007a844622f3d.svg";
export { ForwardRef as ReactComponent };